import { useState, useCallback } from 'react'
import classNames from 'classnames/bind'
import configment from '@adc/configment'
import { Text, constants, Button, AddressSuggestionField } from '@adc/ui-adc'
import { useStepManagerContext } from '../stepManager'
import styles from './styles.scss'

const cx = classNames.bind(styles)
const { ColorNames } = constants

const FirstStep = () => {
  const { data, actions } = useStepManagerContext()
  const { stepProgression, leadIntake } = data
  const { onNextStep } = actions

  const [fieldValue, setFieldValue] = useState('')
  const [hasUserTyped, setHasUserTyped] = useState(false)
  const [isValidAddressSelected, setIsValidAddressSelected] = useState(false)
  const [error, setError] = useState('')

  const onAddressSuggestChange = useCallback(
    (event: any) => {
      const addressSuggestion = event.selectedAddressText?.trim() || ''
      setFieldValue(addressSuggestion)
      setHasUserTyped(true)

      if (event.selectedAddressText && event.is_option_selected) {
        setIsValidAddressSelected(true)
        setError('')

        const updatedLeadIntake = {
          ...leadIntake,
          propertyAddress: {
            formattedAddress: event.selectedAddressText,
            addressComponents: event.addressComponents,
            placeId: event.placeId,
          },
          'property.address': event.street_name,
          'property.street_number': event.street_number,
          'property.city': event.municipality,
          'property.state': event.country_primary_subdivision,
          'property.postal_code': event.postal_code,
          '__computed__.property.addressDisplayText': event.selectedAddressText,
          '__computed__.property.is_option_selected': event.is_option_selected,
        }

        actions.setLeadIntake(updatedLeadIntake)
        actions.setStepProgression({
          ...stepProgression,
          isNextDisabled: false,
        })
      } else if (addressSuggestion.length > 0 && !event.is_option_selected) {
        setIsValidAddressSelected(false)
        setError('')
        actions.setStepProgression({
          ...stepProgression,
          isNextDisabled: true,
        })
      } else if (addressSuggestion.length === 0) {
        setIsValidAddressSelected(false)
        setError(hasUserTyped ? 'Please enter a valid address' : '')
        actions.setStepProgression({
          ...stepProgression,
          isNextDisabled: true,
        })
      }
    },
    [actions, leadIntake, stepProgression, hasUserTyped]
  )

  return (
    <div className={cx('first-step-full-width-section')}>
      <div className={cx('landing-section')}>
        <div className={cx('first-step-header-section')}>
          <Text
            color={ColorNames.White}
            style={{ fontSize: '36px', lineHeight: '40px', fontWeight: '800' }}
          >
            Take the First Step Today
          </Text>
          <Text
            as='p'
            size='large'
            color={ColorNames.White}
            style={{ lineHeight: '28px' }}
          >
            Don't let foreclosure be your only option. Claim your listing now
            and discover what's possible.
          </Text>
        </div>

        <div className={cx('address-box-first-step')}>
          <div className={cx('address-field-container-first-step')}>
            <AddressSuggestionField
              name='address_suggestion'
              elmId='property_address_suggestion_field_first_step'
              className={cx('address-suggestion-field-first-step')}
              value={{
                selectedAddressText: fieldValue,
              }}
              onChange={onAddressSuggestChange}
              googleApiConfig={{
                channelName: configment.get('GOOGLE_MAPS_CHANNEL_NAME', ''),
                apiKey: configment.get('GOOGLE_MAPS_API_KEY', ''),
              }}
              displayFormattedAddress
              googleAutocompleteOptions={{
                componentRestrictions: { country: ['us', 'pr'] },
              }}
              touched={hasUserTyped}
              error={error}
              placeholder='Enter your property address'
            />

            <Button
              isStretch
              role='primary'
              disabled={!isValidAddressSelected}
              onClick={onNextStep}
              loading={stepProgression.isCurrentlyValidating}
              elmId='h_sell_first_step'
            >
              Start My Property Listing
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FirstStep
